// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IExistingUserRequest {
    static getAttributeTypeMap() {
        return IExistingUserRequest.attributeTypeMap;
    }
}
IExistingUserRequest.discriminator = undefined;
IExistingUserRequest.additionalProperties = false;
IExistingUserRequest.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "string"
    },
    {
        "name": "username",
        "baseName": "username",
        "type": "string"
    },
];
//# sourceMappingURL=iExistingUserRequest.js.map